import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
@Component({
  selector: 'app-cheque-no',
  templateUrl: './../../../templates/forms/modals/budget-list.component.html',
})
export class BudgetListComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Input()
  selectedStatus: string;

  @Input()
  canChangeBusinessUnit: string;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  searchFields: any[] = ['BU_NAME', 'STAT'];
  public searchString;

  dataObj: any;

  budgetList: any[] = [];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "BudgetListGrid"

  constructor(public langService: LangService,
    private comService: CommonService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.bUName, field: 'BU_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.budgetNo, field: 'BU_NO', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.stat, field: 'STAT', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);

    this.comService.getBudgetViews(this.selectedStatus, this.canChangeBusinessUnit).subscribe(result => {
      this.budgetList = result.body;
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
